import { Backdrop, CircularProgress } from '@mui/material';
import { useAppSelector } from 'src/store/hooks';

const Loader: React.FC = () => {
  const open = useAppSelector(state => state.loader.isLoading);
  return (
    <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={open}>
      <CircularProgress />
    </Backdrop>
  );
};

export default Loader;
